import React, { Component } from "react"
import styled from "styled-components"

const SectionContainer = styled.div`
  position: relative;
  z-index: ${props => props.zIndex};
  margin: 0 auto;
  padding: 0 1.5rem;
  display: flex;
  flex-direction: ${props => (props.reversed ? "row-reverse" : "row")};
  align-items: center;
  justify-content: center;
  min-height: ${props => props.height};
  width: 100%;
  max-width: 1600px;
  margin-bottom: 50px;

  @media (max-width: 980px) {
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: center;
    justify-content: center;
    padding: 0 1rem;
  }

  @media screen and (max-width: 615px) {
    padding: 0 0.8rem;
    margin-bottom: 20px;
  }
`

export default ({ children, reversed, height, zIndex }) => (
  <SectionContainer zIndex={zIndex} reversed={reversed} height={height}>
    {children}
  </SectionContainer>
)



// WEBPACK FOOTER //
// ./src/components/SectionContainer.js